const currentScript = document.currentScript || (() => {
    const scripts = document.getElementsByTagName('script')
    return scripts[scripts.length - 1]
})()

export default currentScript


// WEBPACK FOOTER //
// ./src/shared/helpers/current-script.js